$(document).ready(function () {

    $(document).on('click', '#purchase', function () {

        const giftStatus = $('#gift_status').val();
        if (giftStatus === 'Y' && !$('input[name="regalo_obtenido"]:checked').length) {
            swal.fire({
                title: 'Advertencia',
                text: 'Por favor selecciona un regalo para continuar.',
                icon: 'error',
            });
            return false;
        }

        let method = $("input[name='payment']:checked").val();

        if (method == 'card') {
            validate_credit_card();
        }

        switch (method) {
            case "card":
                card();
                break;
            case "spei":
                pay(method);
                break;
            case "store":
                pay(method);
                break

            default:
                swal.fire('Advertencia', 'Seleccione un método de pago', 'error')
                    .then(() => {

                    });
                break;
        }
    });

    window.pay = function (method) {

        $("#div_loading").addClass("loading-almadia");

        let data = new FormData();
        data.append('method', method);
        data.append('device_session_id', $("#deviceIdHiddenFieldName").val());
        data.append('source_id', $("#source_id").val());
        data.append('bill', $("input[name='factura']:checked").val());
        data.append('gifts', $("input[name='gifts']:checked").val());
        //data.append('gifts_msg', $("#gifts_msg").val());
        data.append('gifts_msg', '');
        const giftStatusValue = $('#gift_status').length ? $('#gift_status').val() : 'N';
        data.append('gift_status', giftStatusValue);
        const regaloSeleccionado = $('input[name="regalo_obtenido"]:checked').val() || '0';
        data.append('gift_id', regaloSeleccionado);

        $.ajax({
            url: window.location.origin + '/charge/charge',
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                $("#div_loading").removeClass("loading-almadia");
                if (response.status === 'fail') {
                    responseAlert(response);
                } else {
                    if (response.method === 'card') {
                        if (response.status === 'charge_pending') charge_3D_secure(response);
                        else msj_rollback();
                    } else {
                        if (response.status === 'in_progress') responseAlert(response);
                        else msj_rollback();
                    }
                }
            },
            error: function (errors, xhr, status,) {
                $("#div_loading").removeClass("loading-almadia");

                let msj = openpay_responseJSON(errors);
                swal.fire({
                    title: 'Advertencia',
                    text: msj,
                    icon: 'error',
                    confirmButtonColor: '#003b5a',
                }).then((result) => {
                    $('.method').prop("disabled", false);
                });
            }
        })
    }

    window.validate_credit_card = function () {

        let card = $('input:text[name=number]').val();
        let name = $('input:text[name=first-name]').val();
        let expiry = $('input:text[name=expiry]').val();
        let cvv = $('input:text[name=cvc]').val();

        card = card.replace(/ /g, "");
        expiry = expiry.replace(/ /g, "");

        let arr = expiry.split('/');

        let mm = arr[0];
        let yy = arr[1];

        let view = "<form id='formTokenizacion' method='POST'>" +
            "<input type='hidden' data-openpay-card='holder_name' value='" + name + "' >" +
            "<input type='hidden' data-openpay-card='card_number' value='" + card + "' >" +
            "<input type='hidden' data-openpay-card='expiration_month' value='" + mm + "' >" +
            "<input type='hidden' data-openpay-card='expiration_year' value='" + yy + "' >" +
            "<input type='hidden' data-openpay-card='cvv2' value='" + cvv + "' >" +
            "<input type='hidden' name='source_id' id='source_id'>" +
            "</form>";

        $("#formOpenPay").html(view);
    }

    window.openpay_messages = function (response) {

        let msj = response.data.description != undefined ? response.data.description : response.message;

        switch (msj) {
            case "holder_name is required":
                return " El nombre titular de la tarjeta es obligatorio.";

            case "card_number is required, card_number is required":
                return "El número de tarjeta es obligatorio.";

            case "card_number length is invalid":
                return "La longitud del número de tarjeta no es válida.";

            case "card_number must contain only digits":
                return "El número de la tarjeta debe contener solo dígitos.";

            case "card_number length must be between 12 and 19, card_number length is invalid":
                return "La longitud del número de tarjeta no es válida. La longitud del número de tarjeta debe estar entre 12 y 19.";

            case "The card number verification digit is invalid":
                return "El número de tarjeta no es válido.";

            case "expiration_month 00 is invalid, valid expirations months are 01 to 12":
                return "Los meses de vencimiento válidos son del 01 al 12.";

            case "expiration_month we is invalid, valid expirations months are 01 to 12":
                return "El mes de vencimiento no es válido, los meses de vencimiento válidos son del 01 al 12.";

            case "expiration_year expiration_month is required":
                return "El año de vencimiento o es obligatorio.";

            case "cvv2 length must be 3 digits":
                return "La longitud de cvv debe ser de 3 dígitos.";

            case "The CVV2 security code is required":
                return "Se requiere el código de seguridad cvv.";

            case "cvv2 must contain only digits":
                return "El cvv2 debe contener solo dígitos.";

            case "cvv2 length must be 4 digits":
                return "La longitud de cvv debe ser de 4 dígitos.";

            case "The expiration date has expired":
                return "La fecha de caducidad ha expirado.";

            default:
                //console.log(response);
                return msj;
        }
    }

    window.openpay_responseJSON = function (jqXHR) {

        let msj = jqXHR['responseJSON']['message'];

        switch (msj) {
            case "Invalid promotion for such card type":
                return "Promoción no válida para este tipo de tarjeta.";

            case "Transaction amount is less than minimum for promotion":
                return "El monto de la transacción es menor que el mínimo para la promoción.";

            case "The card was declined by the bank":
                return "La tarjeta fue rechazada por el banco.";

            case "The card has expired":
                return "La tarjeta ha caducado.";

            case "The card doesn't have sufficient funds":
                //return "La tarjeta no tiene fondos suficientes.";
                return "La tarjeta fue declinada";

            case "The card was reported as stolen":
                //return "La tarjeta fue reportada como robada";
                return "La tarjeta fue declinada";

            case "Fraud risk detected by anti-fraud system":
                //return "Riesgo de fraude detectado por el sistema antifraude.";
                return "La tarjeta fue declinada";

            case "The amount must be greater than zero.":
                return "La cantidad debe ser mayor que cero.";

            default:
                //console.log(msj);
                //return 'Ocurrió un problema';
                return "La tarjeta fue declinada";
        }
    }

    window.charge_3D_secure = function (response) {
        if (response.type === 'redirect') {
            window.location.href = response.url;
        } else {
            alert('Ocurrió un problema al validar el 3D Secure')
        }
    }

    //$('input[name=payment]').change(function () {
    $(document).on('change', 'input[name=payment]', function () {

        if ($("input[name='payment']:checked").val() === 'card') {
            $('#tarjeta').show();
        } else {
            $('#tarjeta').hide();
        }

        if ($("input[name='payment']:checked").val() === 'paypal') {
            validatePaypal();
            $('#paypal-button-container').hide();
        } else {
            $('#paypal-button-container').hide();
            $('#validate').hide();
            $('#purchase').show();
        }

        if ($("#credit_card").length > 0) {
            const c = new Card({
                form: '#credit_card',
                container: '.card-wrapper',
                formSelectors: {
                    nameInput: 'input[name="first-name"]'
                },
                placeholders: {
                    number: '**** **** **** ****',
                    name: 'Nombre Completo',
                    expiry: '**/**',
                    cvc: '***'
                },
                messages: {
                    validDate: 'Valida\nhasta',
                    monthYear: 'Mes/Año'
                },
            });
            //$('.chosen-select').chosen({width: '100%'});
        }
    });

    function validatePaypal() {
        if ($("input[name='payment']:checked").val() === 'paypal') {
            $('#purchase').hide();
            $('#validate').show();
            $('#paypal-button-container').hide();
        }
    }

    $(document).on('click', '#validate', function (e) {

        let data = new FormData();
        data.append('bill', $("input[name='factura']:checked").val());

        const giftStatus = $('#gift_status').val();
        if (giftStatus === 'Y' && !$('input[name="regalo_obtenido"]:checked').length) {
            swal.fire({
                title: 'Advertencia',
                text: 'Por favor selecciona un regalo para continuar.',
                icon: 'error',
            });
            return false;
        }

        $.ajax({
            url: window.location.origin + '/paypal/validate',
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                $("#div_loading").removeClass("loading-almadia");
                if (response.status === 'fail') {
                    responseAlert(response);
                } else {
                    $('#validate').hide();
                    $('#paypal-button-container').show();
                }
            },
            error: function (errors, xhr, status,) {
                $("#div_loading").removeClass("loading-almadia");
                msj_rollback();
            }
        })
    })

    if ($("#paypal-button-container").length > 0) {

        try {
            paypal.Buttons({
                style: {
                    layout: 'horizontal',
                    tagline: false,
                    color: 'white',
                    height: 40,
                },
                createOrder: function (data, actions) {

                    let bill = $("input[name='factura']:checked").val();
                    let gifts = $("input[name='gifts']:checked").val();
                    //let gifts_msg = $("#gifts_msg").val();
                    let gifts_msg = 'NA';

                    if (bill == undefined) bill = 'N';
                    if (gifts == undefined) gifts = 'N';
                    //if (gifts_msg == '') gifts_msg = 'NA';

                    const giftStatusValue = $('#gift_status').length ? $('#gift_status').val() : 'N';
                    let gift_status = giftStatusValue;
                    const regaloSeleccionado = $('input[name="regalo_obtenido"]:checked').val() || '0';

                    let gift_id = regaloSeleccionado;


                    return fetch('/payment/paypal/' + bill + '/' + gifts + '/' + gifts_msg+ '/' + gift_status+ '/' + gift_id, {
                        method: 'get',
                    }).then(function (res) {
                        return res.json();
                    }).then(function (orderData) {
                        return orderData.id;
                    });
                },
                onApprove: function (data, actions) {
                    return fetch('/paypal/capture/' + data.orderID, {
                        method: 'get'
                    }).then(function (res) {
                        return res.json();
                    }).then(function (orderData) {

                        let errorDetail = Array.isArray(orderData.details) && orderData.details[0];

                        if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
                            return actions.restart();
                        }

                        if (errorDetail) {
                            let msg = 'Lo sentimos, su transacción no pudo ser procesada.';

                            if (errorDetail.description) msg += '\n\n' + errorDetail.description;
                            if (orderData.debug_id) msg += ' (' + orderData.debug_id + ')';
                            return alert(msg);
                        }

                        //console.log('detalles ', orderData, JSON.stringify(orderData, null, 2));
                        let transaction = orderData.purchase_units[0].payments.captures[0];
                        //console.log('Transacción ' + transaction.status + ': ' + transaction.id);
                        //LLamar en ajax para guardar pedido borrarr carrito y redirigir a pedidos

                        if (transaction.status === 'COMPLETED') {
                            setTimeout(function () {
                                swal.fire({
                                    title: 'Generado',
                                    text: 'El pedido se realizó correctamente.',
                                    icon: 'success',
                                    confirmButtonColor: '#003b5a',
                                }).then((result) => {
                                    window.location.href = window.location.origin + "/mis-pedidos";
                                });
                            }, 500);
                        }
                    });
                }
            }).render('#paypal-button-container');
        } catch (err) {
            //Si aparece paypal.Buttons is not a function es por que no hay internet no se puede probar sin internet
            document.getElementById("paypal-button-container").innerHTML = err.message;
        }
    }

    // Funcionalidad de zoom para imágenes
    const $body = $('body');
    const $zoomContainer = $('<div>', {
        class: 'zoom-container'
    }).appendTo($body);

    $(document).on('mouseenter', '.gift-img-zoom', function(e) {
        const $this = $(this);

        $zoomContainer.empty();

        $('<img>', {
            class: 'zoomed-image',
            src: $this.attr('src')
        }).appendTo($zoomContainer);

        const offset = $this.offset();
        const imgWidth = $this.width();
        const zoomedWidth = 350;

        $zoomContainer.css({
            'display': 'block',
            'top': offset.top - 350 - 20,
            'left': offset.left + (imgWidth/2) - (zoomedWidth/2)
        });

        const $zoomedImg = $zoomContainer.find('.zoomed-image');
        const scale = 1.5;

        $zoomedImg.css({
            'transform': `scale(${scale})`
        });
    });

    $(document).on('mouseleave', '.gift-img-zoom', function() {
        $zoomContainer.empty().css('display', 'none');
    });


});
